
































































import Vue from 'vue'
import Component from 'vue-class-component';
import {State} from 'vuex-class'
import Api from '@/modules/app-router/model/Api'
import ApiVersionDetail from '@/modules/app-router/components/ApiVersion/ApiVersionDetail.vue'
import ApiVersion from '@/modules/app-router/model/ApiVersion'
import {notify} from '@/modules/core/notification'

/**
 * Lista de versiones de API
 *
 * Muestra la lista de versiones de la API seleccionada por el usuario
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: { ApiVersionDetail },
})
export default class ApiVersionList extends Vue {
    @State(state => state.appRouter.currentApi)
    public api: Api

    public deleteConfirm = false
    public removing = false

    public get versionDetail () {
        return this.$store.state.appRouter.apiVersionDetail
    }

    public set versionDetail (display: boolean) {
        this.$store.commit('appRouter/TOGGLE_API_VERSION_DETAIL', display)
    }

    /**
     * Activa el dialogo que pide al usuario la confirmación para eliminar
     * una versión de API
     *
     * @param version {ApiVersion}
     */
    public activeDeleteConfirm (version: ApiVersion) {
        this.$store.commit('appRouter/SET_CURRENT_API_VERSION', version)
        this.deleteConfirm = true
    }

    /**
     * Seleccionada una versión la API
     *
     * Abre el dialogo para visualizar/editar los detalles de la versión de la API
     * seleccionada.
     *
     * @param version
     */
    public async selectVersion (version: ApiVersion | null = null) {
        await this.$store.dispatch('appRouter/loadApiVersion', version)
        this.versionDetail = true
    }

    /**
     * Solicita a la aplicación la eliminación de la versión de la API
     * actualmente seleccionada
     */
    public async remove () {
        this.removing = true
        await this.$store.dispatch('appRouter/deleteApiVersion')

        this.deleteConfirm = false
        this.removing = false
        notify('La versión se ha eliminado correctamente')
    }

    public errorCaptured (error: Error) {
        this.removing = false
    }
}
